import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { CustomSnackbarService } from '@shared/components/custom-snackbar/custom-snackbar.service';

@Component({
    selector: 'app-zendesk-sso',
    template: '<form id="jwtForm" method="post" action="https://cybereadysupport.zendesk.com/access/jwt?return_to={{returnUrl}}"><input id="jwtInput" type="hidden" name="jwt" /></form>',
    standalone: false
})
export class ZendeskSSOComponent implements OnInit {
  public returnUrl: string = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private customSnackbarService: CustomSnackbarService,
  ) {}

  ngOnInit() {
    this.returnUrl =
      this.route.snapshot?.queryParams['return_to'] ||
      'https://support.cybeready.com/hc/en-us';

    this.authService.getZendeskSSOToken().subscribe(
      (get_response) => {
        const token = get_response.token;
        const jwtToken = document.getElementById('jwtInput');
        jwtToken['value'] = token;
        document.forms['jwtForm'].submit();
      },
      (error) => {
        console.error('Error logging in to Zendesk', error);
        // Optionally, you can redirect to an error page or show a message
        this.customSnackbarService.showSnackbar(
          'Error logging in to Zendesk',
          'warning',
        );
      },
    );
  }
}
